import { useMutation, useQuery, useQueryClient } from "react-query";
import { bulkDeleteTasksPermanently, deleteTaskPermanently, getDeletedTasks, restoreDeletedTask, } from "@/features/taskTrash/services/taskTrashService";
const getTrashQueryKey = (page, filters, limit) => [
    "tasksTrash",
    page,
    JSON.stringify(filters),
    limit,
];
const useTaskTrash = (page = 1, filters = {}, limit = 10) => {
    const queryClient = useQueryClient();
    const { data, error, isLoading, refetch } = useQuery(getTrashQueryKey(page, filters, limit), () => getDeletedTasks(page, filters, limit), {
        keepPreviousData: true,
        staleTime: 60000,
    });
    const invalidateTrash = () => {
        void queryClient.invalidateQueries({ queryKey: ["tasksTrash"] });
    };
    const restoreMutation = useMutation((taskId) => restoreDeletedTask(taskId), {
        onSuccess: () => {
            invalidateTrash();
        },
    });
    const deleteMutation = useMutation((taskId) => deleteTaskPermanently(taskId), {
        onSuccess: () => {
            invalidateTrash();
        },
    });
    const bulkDeleteMutation = useMutation((taskIds) => bulkDeleteTasksPermanently(taskIds), {
        onSuccess: () => {
            invalidateTrash();
        },
    });
    return {
        tasks: data?.tasks ?? [],
        meta: data?.meta ?? null,
        loading: isLoading,
        error: error?.message ?? null,
        refetchTrash: refetch,
        restoreTask: restoreMutation.mutateAsync,
        deleteTask: deleteMutation.mutateAsync,
        bulkDeleteTasks: bulkDeleteMutation.mutateAsync,
    };
};
export default useTaskTrash;
